export default "__VITE_ASSET__DwiBL9Fg__"